<div
  [attr.data-ua-id]="trackingId"
  [ngClass]="['loading-spinner-' + getConfig.color, 'loading-spinner-' + getConfig.size]"
  class="loading-spinner"
></div>
